import {
  ButtonLoadingEllipsis,
  OutlineButton,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CartProduct } from "../../../CartProduct";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { CartTotal } from "./CartTotal";
import { ErrorAndTerms } from "./ErrorAndTerms";

const CartContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  backgroundColor: "#f6f8fa",
  paddingTop: 37,
  paddingBottom: 32.8,
  paddingLeft: 32,
  paddingRight: 32,
  minWidth: 400,
  borderRadius: 8,
}));

const CartHeader = styled("div")({
  fontSize: "20px",
  fontWeight: 600,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const CurrentCart = () => {
  const [state, send] = useCheckoutUI();

  const { checkoutIntent } = state.context;

  const navigate = useNavigate();

  const cartItems = checkoutIntent?.items;

  if (!cartItems?.length) {
    return null;
  }

  return (
    <CartContainer>
      <CartHeader>
        Order Summary
        <OutlineButton
          onClick={() => navigate("/mybag")}
          disabled={state.value === "checking_out"}
        >
          Edit
        </OutlineButton>
      </CartHeader>
      {cartItems.map((item) => (
        // @ts-ignore
        <CartProduct key={item.stacklineSku} product={item} editable={false} />
      ))}
      <CartTotal />

      {["ready_to_checkout", "checking_out"].includes(state.value as string) ? (
        <SolidButton
          onClick={() => send({ type: "SUBMIT_CHECKOUT" })}
          disabled={state.value !== "ready_to_checkout"}
        >
          {state.value === "checking_out" ? (
            <ButtonLoadingEllipsis baseFontSize={16} />
          ) : (
            "Submit my order"
          )}
        </SolidButton>
      ) : (
        <OutlineButton disabled>Submit my order</OutlineButton>
      )}
      <ErrorAndTerms />
    </CartContainer>
  );
};
